module.exports = __webpack_public_path__ + "img/snelterecht-logo.f1e1af56.png";